module.exports = __webpack_public_path__ + "img/yc-bg3-btn.478d08d3.png";